import React from "react";
import logger from "logger";
import { hostname } from "Utils/Constants";
import { getStyleJSON } from "Utils/Common";

export default function({ email }) {
  return (
    <div align="center">
      <div align="center">
        <form
          action="https://www.paypal.com/cgi-bin/webscr"
          method="post"
          target="_top"
        >
          <input type="hidden" name="cmd" value="_s-xclick" />
          <table>
            <tr>
              <td>
                <input type="hidden" name="on0" value="Credits" />
              </td>
            </tr>
            <tr>
              <td>
                <select name="os0" style={getStyleJSON("display: none;")}>
                  <option value="4000 Creds">4000 Creds $10.00 USD</option>
                  <option value="10000 Creds">10000 Creds $20.00 USD</option>
                  <option value="30000 Creds">30000 Creds $50.00 USD</option>
                </select>
              </td>
            </tr>
          </table>
          <input
            type="hidden"
            name="custom"
            value={`hgaccountenable:${email}:${hostname}`}
            ng-show="true"
            style={getStyleJSON("display: block;")}
          />
          <input type="hidden" name="currency_code" value="USD" />
          <input
            type="hidden"
            name="encrypted"
            value="-----BEGIN PKCS7-----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-----END PKCS7-----"
          />
          <input
            type="image"
            src="https://www.paypalobjects.com/en_GB/i/btn/btn_buynowCC_LG.gif"
            border="0"
            name="submit"
            style={getStyleJSON("width: auto;")}
            alt="PayPal – The safer, easier way to pay online!"
          />
          <img
            alt=""
            border="0"
            style={getStyleJSON("display: none;")}
            src="https://www.paypalobjects.com/en_GB/i/scr/pixel.gif"
            width="1"
            height="1"
          />
        </form>
      </div>
    </div>
  );
}
